export enum GameError {
    INVALID_PATH,
    UNKNOWN_COMMAND,
    NO_ITEM,
}
